<script>
export default {
  name: 'AoikumoIntegrationTag',
  props: {
    // A service or staff member: `provider_links.aoikumo` is
    // `{ integration_id, integration_name, external_id }`, or null for a local
    // (non-Aoikumo) item.
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    integrationName() {
      return this.item?.provider_links?.aoikumo?.integration_name || '';
    },
    isVisible() {
      return (
        this.$store.getters['aoikumo/isConnected'] && !!this.integrationName
      );
    },
  },
};
</script>

<template>
  <span
    v-if="isVisible"
    class="inline-flex self-start items-center px-2 py-0.5 text-xs font-medium rounded-full bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200"
    data-testid="aoikumo-integration-tag"
    :title="integrationName"
  >
    {{ $t('AOIKUMO_INTEGRATION_TAG', { name: integrationName }) }}
  </span>
</template>
